<div #scroll class="container-table-config">
  <div class="container-configuration" id="dataTable">
    <div
      [ngClass]="{ 'exist-paginator': dataTable.paginator && data && data.length && data.length>0}"
      class="container-header"
      *ngIf="
        dataTable.filter ||
        dataTable.searchText ||
        dataTable.addText ||
        paginatorValues.limit ||
        (dataTable.export && data && data.length)
      "
    >
      <div *ngIf="paginatorValues.limit && dataTable.paginator">
        <app-paginator
          (page)="onChangePage($event)"
          [limit]="paginatorValues.limit"
          [offset]="paginatorValues.offset"
          [stopNextPaginator]="stopNextPaginator"
          [limitOptions]="paginatorValues.limitOptions"
          [totalRecords]="paginatorValues.totalRecords"
        >
        </app-paginator>
      </div>
      <div class="content-actions">
        <mat-form-field *ngIf="dataTable.filter">
          <mat-select
            [id]="id + 'tableFilterFilter'"
            [formControl]="filterControl"
            (selectionChange)="filterRecords($event.value)"
            disableOptionCentering="true"
          >
            <mat-option
              *ngFor="let item of listFilter | async"
              [value]="item.id"
              [id]="id + 'tableFilterFilter-' + item.id"
            >
              {{ item.text || item.department }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="dataTable.searchText" class="flex-grow-1 search">
          <mat-icon class="icon">search</mat-icon>
          <input
            [id]="id + 'tableFilterSearch'"
            [placeholder]="dataTable.searchText"
            matInput
            (keyup)="search($event.target.value, dataTable.searchTextService)"
            autocomplete="off"
            [formControl]="searchControl"
          />
        </div>
        <ng-content></ng-content>
        <button
        *ngIf="dataTable.export && data && data.length"
        [id]="id + 'tableFilterExport'"
        mat-flat-button
        class="button-export"
        (click)="export()"
      >
        <mat-icon matSuffix svgIcon="excel"></mat-icon> <span> Exportar</span>
      </button>
        <button
          *ngIf="dataTable.exportAdditional && data && data.length"
          [id]="id + 'tableFilterExport'"
          mat-flat-button
          class="button-export"
          (click)="exportAditional()"
        >
          <mat-icon matSuffix>save_alt</mat-icon>
          <span> {{ dataTable.exportNameAdditional }}</span>
        </button>
        <button
          *ngIf="visibleButton && dataTable.addText"
          [id]="id + 'tableFilterAdd'"
          mat-flat-button
          class="button-success recordColumn"
          (click)="
            dataTable.dialogHability ? emitDialog() : onClickButtonHeaderTable()
          "
          [disabled]="!disabledButton && dataTable.disabled"
        >
          <mat-icon matSuffix *ngIf="!dataTable.iconAddText">add</mat-icon>
          <mat-icon
            matSuffix
            *ngIf="dataTable.iconAddText"
            class="iconAddText"
            >{{ dataTable.iconAddText }}</mat-icon
          >
          <span>{{ dataTable.addText }}</span>
        </button>
        @if (visibleButton && dataTable.secondaryButtonText) {
          <button
            [id]="id + 'tableFilterSecondary'"
            mat-flat-button
            color="primary"
            class="recordColumn"
            (click)="secondaryActionButton.emit(selection.selected)"
          >
            <mat-icon matSuffix>{{ dataTable.secondaryButtonIcon || 'edit' }}</mat-icon>
            <span>{{ dataTable.secondaryButtonText }}</span>
          </button>
        }
      </div>
    </div>
    <div class="container-table" [ngClass]="size">
      <table
        mat-table
        [dataSource]="dataSource"
        multiTemplateDataRows
        matSort
        [attr.multiTemplateDataRows]="true"
      >
        <ng-container *ngIf="dataTable.checkbox" cdkColumnDef="select">
          <th mat-header-cell *cdkHeaderCellDef>
            <mat-checkbox
              (change)="$event ? onChangeMasterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [disabled]="isDisableMasterCheckbox()"
              (click)="onClickSelection()"
              [id]="id + 'checkbox-all-th'"
              *ngIf="data && dataTable.checkboxHeader != false"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *cdkCellDef="let row; let i = dataIndex" [ngClass]="addClas(row)">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? isCheck(row, i) : null"
              [checked]="selection.isSelected(row)"
              [disabled]="hasDisableCheckbox(row)"
              [aria-label]="checkboxLabel(row)"
              [id]="id + 'checkbox-td-' + i"
              *ngIf="dataTable.checkboxRow != false"
            >
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container
          *ngFor="let action of actionHeader; let i = index"
          [matColumnDef]="action.icon"
        >
          <th
            mat-header-cell
            *cdkHeaderCellDef
            [attr.colspan]="this.displayedColumns.length"
          >
            <div class="header-content">
              <mat-checkbox
                (change)="$event ? onChangeMasterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [disabled]="isDisableMasterCheckbox()"
                [id]="id + 'checkbox-all-th-replace'"
                class="check-action-header"
                *ngIf="dataTable.checkboxHeader != false"
              >
              </mat-checkbox>
              <ng-container *ngFor="let icons of action.action; let i = index">
                <button
                  mat-icon-button
                  [id]="id + 'header-icon-' + icons.icon"
                  [hidden]="hasHiddenIconHeader(icons)"
                  [matMenuTriggerFor]="icons.dropdown?.length ? menu : null"
                  (click)="onClickIconHeader(icons.icon, icons.dropdown, icons.type); $event.stopPropagation()"
                >
                  <mat-icon
                    class="icon-table"
                    [svgIcon]="icons.icon"
                    [matTooltip]="icons.tooltip"
                  >
                  </mat-icon>
                </button>

              <mat-menu #menu="matMenu" yPosition="above">
                <button
                  mat-menu-item
                  *ngFor="let item of icons.dropdown"
                  (click)="onClickIconHeader(item.value)"
                  [id]="id + item.value"
                  [disabled]="disabledDropDown(item.value)"
                >
                  {{ item.text }}
                </button>
              </mat-menu>
            </ng-container>
            </div>
          </th>
        </ng-container>
        <ng-container
          *ngFor="let item of dataTable.columns; let i = index"
          [cdkColumnDef]="item.name"
        >
          <th
            mat-header-cell
            [disabled]="!item.sort"
            *cdkHeaderCellDef
            class="element-row"
            [ngClass]="renderClassObject(item)"
            mat-sort-header
            (click)="onClickSortServer(i)"
          >
            {{ item.title }}
            <mat-slide-toggle
              *ngIf="item.type === 'boolean' && item.editable && item.checkAll"
              [id]="id + 'tableFilter-' + item.name"
              class="recordColumn ms-1"
              color="primary"
              [checked]="item.toggleValue()"
              (change)="updateRecord(item.name,$event.checked)"
            >
            </mat-slide-toggle>
            <button
              class="btn-alterColumns"
              *ngIf="dataTable.alterColumns && item.type === 'editableColumns'"
              [id]="id + 'tableListColumns'"
              mat-icon-button
              matTooltip="Mostrar columnas"
              (click)="onClickListColumns()"
            >
              <mat-icon class="icon-alterColumns">grid_on</mat-icon>
            </button>
          </th>
          <td
            mat-cell
            *cdkCellDef="let element; let i = dataIndex"
            [id]="id + 'tableFilter-td-' + item.name + '-' + i"
            class="element-row tableFilter-td-{{ i }} {{item.class}}"
            [ngClass]="addClas(element)"
          >
            <span
              *ngIf="item.type === 'string' && !item.editable"
              [ngClass]="item.expand ? item.expand : 'recordColumn'"
            >
              {{ item.value(element) }}
            </span>
            <mat-form-field
              *ngIf="item.type === 'string' && item.editable && !hability"
              [id]="id + 'tableFilter-' + item.name + '-' + i"
              class="recordColumn"
            >
            <mat-label>{{item.title}}</mat-label>
              <input
                matInput
                [value]="item.value(element)"
                [disabled]="itemDisabled[i]"
                (blur)="
                  updateRecordInline(item.name, element, $event.target['value'], i)
                "
              />
            </mat-form-field>
            <mat-form-field
            *ngIf="item.type === 'newSelect' && item.editable"
            [id]="id + 'tableFilter-' + item.name + '-' + i"
            class="recordColumn"
          >
          <mat-label>{{item.placeholderHidden ? '' : item.title}}</mat-label>
            <mat-select
              (selectionChange)="onChangeSelect($event, i)"
              [value]="item.value(element).value"
              [id]="item.value(element).value + '-' + i"
            >
              <mat-option
                *ngFor="let option of item.value(element).options; let x = index"
                [value]="option.id"
                [id]="option.id + '-' + x"
                >{{ option.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>
            <mat-form-field
              *ngIf="item.type === 'select' && item.editable"
              [id]="id + 'tableFilter-' + item.name + '-' + i"
              class="recordColumn"
            >
            <mat-label>{{item.placeholderHidden ? '' : item.title}}</mat-label>
              <mat-select
                (selectionChange)="onChangeSelect($event, i)"
                [value]="isAllSelect ? isAllSelect : item.value(element)[0]?.id"
                [id]="item.value(element)[0]?.id + '-' + i"
              >
                <mat-option
                  *ngFor="let option of item.value(element); let x = index"
                  [value]="option.id"
                  [id]="option.id + '-' + x"
                  >{{ option.text }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              [ngStyle]="{
                width: hability ? '70px' : 'auto',
                'text-align': 'center'
              }"
              *ngIf="item.type === 'string' && item.editable && hability"
              [id]="id + 'tableFilter-' + item.name + '-' + i"
              class="recordColumn"
            >
            <mat-label>{{item.title}}</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="itemValue[i]"
                [disabled]="itemDisabled[i]"
                [value]="item.value(element)"
                (blur)="updateRecordInline(item.name, element, itemValue[i])"
              />
            </mat-form-field>
            <mat-form-field
              [ngStyle]="{ width: '70px' }"
              *ngIf="item.type === 'number' && item.editable"
              [id]="id + 'tableFilter-' + item.name + '-' + i"
              class="recordColumn"
            >
              <input
                matInput
                [min]="item.value(element).min"
                [max]="item.value(element).max"
                type="number"
                [(ngModel)]="item.value(element).num"
                [disabled]="disabledInput(element)"
                [value]="item.value(element).num"
                (blur)="updateRecordInline(item.name, element, $event.target.value, i)"
                autocomplete="off"
              />
            </mat-form-field>
            <ng-container *ngIf="item.listing">
              <p *ngFor="let single of item.value(element)[0]">
                {{ single[item.value(element)[1]] }}
              </p>
            </ng-container>

            <span *ngIf="item.type === 'url' || item.type === 'editableColumns'" class="recordColumn">
              <a
                [routerLink]="item.value(element, currentMenu)['url']"
                [id]="id + 'tableFilter-' + item.name + '-' + i"
                class="p-3"
              >
                <mat-icon>
                  {{ item.value(element, currentMenu)["icon"] }}
                </mat-icon>
                {{ item.value(element, currentMenu)["text"] }}
              </a>
            </span>
            <span
              *ngIf="item.type === 'button' && item.value(element)"
              [class]="item.value(element)['style']"
            >
              <button
                mat-icon-button
                (click)="buttonIcon(element, item.name)"
                [matTooltip]="item.value(element)['value']"
                [disabled]="item.value(element)['disabled']"
              >
                <ng-container *ngIf="item.value(element)['svg']; else elseImage">
                  <mat-icon [svgIcon]="item.value(element)['icon']"></mat-icon>
                </ng-container>
                <ng-template #elseImage>
                  <mat-icon>{{ item.value(element)['icon'] }}</mat-icon>
                </ng-template>
              </button>
              {{
                item.value(element)["showTitle"]
                  ? item.value(element)["value"]
                  : ""
              }}
            </span>
            <span
              class="recordColumn"
              *ngIf="item.type === 'boolean' && !item.editable"
            >
              {{ item.value(element) ? "Activo" : "Inactivo" }}
            </span>
            <mat-slide-toggle
              #toggle
              *ngIf="item.type === 'boolean' && item.editable"
              [id]="id + 'tableFilter-' + item.name + '-' + i"
              class="recordColumn"
              color="primary"
              [checked]="item.value(element)"
              [disabled]="verifyToggleDisabled(element, i)"
              (change)="
                updateRecordInline(item.name, element, $event.checked)
              "
            >
            </mat-slide-toggle>
          </td>
        </ng-container>
        <ng-container *ngIf="dataTable.expandable">
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element; let i = dataIndex"
              class="detail-parent"
              [attr.colspan]="displayedColumns.length"
            >
              <div
                *ngIf="expandableConfig"
                class="detail-container"
                [@detailExpand]="
                  element === expandedElement ? 'expanded' : 'collapsed'
                "
              >
                <app-data-table
                  class="w-100 sub-data-table"
                  [id]="i"
                  [type]="expandableConfig?.type"
                  [data]="expandableConfig?.data"
                  size="large"
                  [expandedFather]="expandedElement"
                  [hability]="true"
                  (updateInline)="onBlurPassingData($event, i)"
                  (update)="onBlurPassingCheck($event, i)"
                  (iconActionHeader)="iconActionTableMultiple($event)"
                  (detail)="onClickButtonIconRow($event)"
                  (onClickIconColumn)="iconActionTableMultiple($event)"
                ></app-data-table>
              </div>
            </td>
          </ng-container>
        </ng-container>
        <tr
          mat-header-row
          *cdkHeaderRowDef="
            showOtherHeader ? headersColumns : displayedColumns;
            sticky: true
          "
          class="table-thead"
        ></tr>
        <tr
          mat-row
          *cdkRowDef="let row; let i = dataIndex; columns: displayedColumns"
          [id]="id + 'tableFilter-row-' + i"
          (click)="shippingType != null && shippingType == 'retiroTienda' ? onClickViewRecord($event, row, 'configuration') : onClickViewRecord($event, row)"
          [ngClass]="{
            'select-row':
              (dataSelect && type === 'shipping'
                ? dataSelect.zoneId === row.zoneId
                : dataTable.expandable && expandedElement === row) ||
              (row === dataSelect && dataTable.selectedRow)
          }"
        ></tr>
        <ng-container *ngIf="dataTable.expandable">
          <tr
            mat-row
            *cdkRowDef="let row; let i = dataIndex; columns: ['expandedDetail']"
            [id]="id + 'tableFilter-detail-row-' + i"
            class="detail-row"
          ></tr>
        </ng-container>
      </table>

      <mat-paginator
        [hidden]="!(dataTable.paginatorAllData && data && data.length>10)"
        [pageSizeOptions]="[5, 10, 25, 50]"
        [pageSize]="10"
        showFirstLastButtons>
      </mat-paginator>

      <div
        [ngClass]="{'height-table': defaultTable}"
        class="default-table height-table vertical-center d-flex align-items-center"
        *ngIf="!data || !data.length"
        id="show"
      >
        <div>
          <img [src]="dataTable.showIcon" *ngIf="dataTable.showIcon" alt="icon infomation"/>
          <p>
            {{
              dataTable.show ||
                "Aplica los filtros y te mostraremos los resultados"
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="shippings.length"
    class="container-configuration description"
    id="description"
  >
    <div [ngClass]="{ 'disabled-table': disabledSubTable }"></div>
    <div class="title-description">
      <span> {{ dataTable.subTable.description }} {{ dataSelect.name }} </span>
    </div>
    <mat-divider></mat-divider>
    <div class="container-table">
      <table mat-table [dataSource]="dataSubTable" class="mat-elevation-z8">
        <ng-container
          *ngFor="let item of dataTable.subTable.columns"
          [cdkColumnDef]="item.name"
        >
          <th mat-header-cell *cdkHeaderCellDef [ngClass]="item.class">
            {{ item.title }}
          </th>
          <td
            mat-cell
            *cdkCellDef="let element; let i = index"
            [id]="id + 'tableFilter-td-' + item.name + '-' + i"
            class="tableFilter-td-{{ i }}"
            [ngClass]="item.class"
          >
            <span
              class="recordColumn"
              *ngIf="item.type !== 'button' && !item.editable"
              class="recordColumn"
            >
              {{ item.value(element) }}
            </span>
            <span *ngIf="item.type === 'button'" class="recordColumn">
              <mat-icon
                (click)="buttonIcon(element, item.name)"
                [matTooltip]="item.value(element)['tooltip']"
                class="icon-table"
                >{{ item.value(element)["icon"] }}</mat-icon
              >
            </span>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumnsSubTable; sticky: true"
          class="table-thead"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsSubTable"
          (click)="onClickViewRecord($event, row, 'configuration')"
        ></tr>
      </table>
    </div>
  </div>
</div>
